import vSelect from 'vue-select'

<template>
  <v-dialog
      v-model="dialog"
      scrollable
      width="500"
      @click:outside="close"
  >
    <v-card>
      <v-overlay
          v-if="loading"
          contained
          :model-value="true"
          class="align-center justify-center"
          persistent
          scrim
      >
        <v-progress-circular
          indeterminate
          size="64"
        ></v-progress-circular>
      </v-overlay>
      <v-toolbar color="primary" dark>
        <v-toolbar-title>{{title}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon variant="text" @click="close">
          <v-icon>far fa-window-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-container fluid>
              <row>
                <col12>
                  <slot name="content"></slot>
                </col12>
              </row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <slot name="buttons"></slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Col12 from "@/components/layout/Col12";
import Row from "@/components/layout/Row";
export default {
  components: {Row, Col12},
  props: {
    'loading': {default: false},
    'title': {default: 'Edit annotations'}
  },
  data () {
    return {
      'dialog': true
    }
  },
  watch: {
    dialog(isOpen) {
      if (!isOpen) {
        this.$emit('close_modal');
      }
    },
  },
  methods: {
    close() {
      this.dialog = false;
    },
  },
}
</script>

<style scoped>
</style>